<template>
  <div v-if="file.meta">
    <b-button :id="'extracted-values-' + file.id" v-if="!!file.meta?.meta?.reason?.length" variant="warning" size="sm"><font-awesome-icon icon="exclamation-triangle"></font-awesome-icon></b-button>
    <b-button :id="'extracted-values-' + file.id" v-else variant="dark" size="sm"><font-awesome-icon :icon="['far', 'eye']"></font-awesome-icon></b-button>
    <b-tooltip :target="'extracted-values-' + file.id" custom-class="w-300 small">
      <b-alert class="p-1 text-left" :show="!!file.meta?.meta?.reason?.length" variant="warning">
        <strong class="small" v-translate>Reasons</strong>
        <ul class="mb-0 pl-3">
          <li v-for="(reason, index) in file.meta?.meta?.reason" :key="index" class="small">{{reason}}</li>
        </ul>
      </b-alert>
      <div class="text-left">
        <strong class="small" v-translate>Extracted</strong>
      </div>
      <b-form-row class="m-0 p-0 small text-left" v-for="(field, index) in Object.keys(correctedFields)" :key="'field-' + index">
        <b-col cols="6">
          <label :for="'field' + index" class="col-form-label">{{field}}</label>
        </b-col>
        <b-col class="col-form-label">
          {{correctedFields[field] || '-'}}
        </b-col>
      </b-form-row>
    </b-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ListItemExtracted',
  props: {
    file: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      possibleFields: {},
      correctedFields: {}
    }
  },
  computed: {
    correctedFieldsComputed() {
      return _.mapValues(this.correctedFields, v => v === '' ? null : v)
    }
  },
  watch: {
    correctedFieldsComputed(val) {
      this.file.meta.corrected_fields = val
    }
  },
  mounted() {
    if (this.file.meta) {
      if (!this.file.meta?.corrected_fields) {
        this.file.meta = { ...this.file.meta, corrected_fields: {} }
      }
      this.possibleFields = Object.entries(this.file.meta?.possible_fields || {})
      this.correctedFields = { ...Object.fromEntries(this.possibleFields.map(x => [x[0], null])), ...this.file.meta.extracted_fields, ...this.file.meta.corrected_fields }
    }
  }
}
</script>

<style lang="scss">
.w-300 {
  width: 300px;
}
</style>
